var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.newIcon)?_c('HeraFormBtn',_vm._b({on:{"click":_vm.goBack}},'HeraFormBtn',Object.assign({}, (!_vm.hideLabel ? { label: _vm.$t('_web_tournament_back', 'Back') } : {}),
    (!_vm.hideIcon
      ? {
          icon: _vm.isRTL ? 'next' : 'back',
          iconSize: _vm.iconSize,
        }
      : {})),false)):_c('img',{staticClass:"new-back-btn-icon",attrs:{"src":require("@/assets/images/back-btn-new.svg"),"alt":"back-icon"},on:{"click":_vm.goBack}})}
var staticRenderFns = []

export { render, staticRenderFns }